<template>
  <div>
    <custom-actions>
      <template #header>
        <el-button type="primary" v-if="hasExport" @click="onDownExcel">导出</el-button>

        <el-button type="primary" v-if="hasAdd" @click="$router.push('/expenseManage/add')">新增</el-button>
      </template>
      <el-form inline ref="searchForm" class="global-form-label-width">
        <el-form-item prop="title" label="标题">
          <el-input clearable v-model="searchForm.title" placeholder="请输入标题" />

        </el-form-item>

        <el-form-item prop="" label="日期">
          <el-date-picker v-model="dateArr" type="daterange" range-separator="-" start-placeholder="开始日期"
            end-placeholder="结束日期" clearable @change="changeDate" format="yyyy-MM-dd" value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

    <el-card class="mt10" shadow="never">
      <div class="flex-end">
        <span>总费用：</span>
        <span class="color">{{ totalExpense || 0 }}</span>（元）
      </div>
      <el-table size="mini" stripe border v-loading="loading" :data="tableData">
        <el-table-column show-overflow-tooltip min-width="100" label="标题" prop="title"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="费用（元）" prop="amount">

        </el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="说明" prop="description">

        </el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="费用发生日期" prop="expenseDate"></el-table-column>

        <el-table-column show-overflow-tooltip min-width="120" label="创建人姓名" prop="createUserName"></el-table-column>

        <el-table-column fixed="right" label="操作" width="160">
          <template v-slot="{ row }">
            <el-button type="text"
              @click="$router.push('/expenseManage/detail?expenseId=' + row.expenseId)">详情</el-button>
            <el-button type="text" v-if="hasEdit" @click="$router.push('/expenseManage/edit?expenseId=' + row.expenseId)">编辑</el-button>

            <el-button type="text" v-if="hasDel" @click="deleteRow(row.expenseId)" class="del-btn">删除</el-button>

          </template>
        </el-table-column>
      </el-table>

      <el-pagination :current-page.sync="page" background layout="total, prev, pager, next" :total="total"
        @current-change="loadData">
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
import { downloadExcelFile } from '@/utils/globalMethods'

export default {
  name: 'expenseManage',

  data() {
    return {
      page: 1,
      total: 0,
      tableData: [],
      loading: false,
      searchForm: {
        startDate: null,
        endDate: null,
        title: null
      },
      dateArr: [],
      totalExpense: 0

    }
  },
  computed: {
    buttonList() {
      return this.$store.state.buttonList.map(item => item.butCode)
    },
    hasAdd() {
      return this.buttonList.includes('add')
    },
    hasEdit() {
      return this.buttonList.includes('edit')
    },
    hasDel() {
      return this.buttonList.includes('delete')
    },
    hasExport() {
      return this.buttonList.includes('export')
    }
  },

  created() {
    this.loadData()
    this.loadTotal()
  },
  methods: {
    loadTotal() {
      this.$axios.get(this.$apis.expenseManage.selectPaExpenseCount, {
        params: {
          ...this.searchForm
        }
      }).then(res => {
        this.totalExpense = res
      })
    },
    loadData() {
      this.loading = true
      this.$axios.get(this.$apis.expenseManage.selectPaExpenseRecordByPage, {
        params: {
          page: this.page,
          ...this.searchForm
        }
      }).then(res => {
        this.tableData = res.list || []
        this.total = res.total || 0
      }).finally(() => {
        this.loading = false
      })
    },

    changeDate(val) {
      if (val && val.length > 0) {
        this.searchForm.startDate = val[0]
        this.searchForm.endDate = val[1]
      } else {
        this.searchForm.startDate = ''
        this.searchForm.endDate = ''
      }
    },
    onSearch() {
      this.page = 1
      this.loadTotal()

      this.loadData()
    },
    resetForm() {
      this.$refs.searchForm.resetFields()
      this.searchForm = {
        startDate: null,
        endDate: null,
        title: null
      }
      this.dateArr = []

      this.onSearch()
    },
    deleteRow(expenseId) {
      this.$confirm('确认删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.expenseManage.deleteDataPaExpenseRecord, {
          expenseId
        }).then(() => {
          this.loadTotal()

          this.loadData()
        })
      })
    },
    onDownExcel () {
      const loadingInstance = this.$loading({
        text: '正在导出...',
        background: 'rgba(0, 0, 0, 0.8)'
      })

      this.$axios.post(this.$apis.expenseManage.exportPaExpenseCount, {
        ...this.searchForm
      }, {
        responseType: 'blob'
      }).then(res => {
        if (res) {
          downloadExcelFile(res.data, '费用管理')
        }
      }).catch(error => {
        console.error('导出失败:', error)
      }).finally(() => {
        loadingInstance.close()
      })
    }

  }
}
</script>

<style scoped lang='scss'>
.btn {
  text-decoration: underline;
  color: #007bff;
  cursor: pointer;
}

.flex-end {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-weight: 600;
  margin-bottom: 10px;

  .color {
    color: #007bff;
    line-height: normal;
    transform: translateY(2px);

  }

}
</style>
